<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="toc"><a id="page_vii"></a><a href="#/xhtml/07_Introduction">Introduction: Triumphalism and President Reagan’s Cold War Legacy</a></p>
<p class="toc"><a href="#/xhtml/08_Chapter01">1. Engaging the Enemy</a></p>
<p class="toc"><span href="#/xhtml/09_Chapter02" title="Link target outside of Sample">2. Reagan’s Military Buildup: “Busting the Soviet Union”?</span></p>
<p class="toc"><span href="#/xhtml/10_Chapter03" title="Link target outside of Sample">3. The Strategic Defense Initiative: Ending the MADness</span></p>
<p class="toc"><span href="#/xhtml/11_Chapter04" title="Link target outside of Sample">4. Soviet New Thinking and the Withdrawal from Afghanistan</span></p>
<p class="toc"><span href="#/xhtml/12_Chapter05" title="Link target outside of Sample">5. Moscow Calls Off the Arms Race</span></p>
<p class="toc"><span href="#/xhtml/13_Chapter06" title="Link target outside of Sample">6. The Triumph of Diplomacy and Leadership</span></p>
<p class="toc"><span href="#/xhtml/14_Acknowledgement" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><span href="#/xhtml/15_Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/xhtml/16_Index01" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Contents.vue?3b84cb82